import React from "react";

export default function FeatureCard({ icon, title, description }) {
  return (
    <div className="feature-card-ini">
      <div className="feature-icon-ini">{icon}</div>
      <h3 className="feature-title-ini">{title}</h3>
      <p className="feature-description-ini">{description}</p>
    </div>
  );
}